import { Offer_Fulfillment_Operator } from '@occc/graphql';

import { FulfillmentFormValues, OfferFulfillment } from '../../types';

export const fulfillmentItems = [
  {
    title: 'Fulfilled',
    value: OfferFulfillment.Fulfilled,
  },
  {
    title: 'Not Fulfilled',
    value: OfferFulfillment.NotFulfilled,
  },
];

export const operatorsOptions = [
  { label: 'Clear Selection', value: '' },
  { label: 'Exactly', value: Offer_Fulfillment_Operator.IsEqualTo },
  { label: 'More than', value: Offer_Fulfillment_Operator.IsGreaterThan },
  {
    label: 'More or equal to',
    value: Offer_Fulfillment_Operator.IsGreaterThanOrEqualTo,
  },
  { label: 'Less than', value: Offer_Fulfillment_Operator.IsLessThan },
  { label: 'Less or equal to', value: Offer_Fulfillment_Operator.IsLessThanOrEqualTo },
];

export const fulfillmentItemInitialValues: FulfillmentFormValues = {
  fulfilled: OfferFulfillment.Fulfilled,
  targetOffer: undefined,
};
